import React from 'react';
import { environment } from '../../../../config/environments';
import './Print.css';
import { FaFilePdf } from 'react-icons/fa';
import { Geo360AdmTenantGate } from '../../Geo360AdmTenantGate';

const RelatorioCusto: React.FC = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <Geo360AdmTenantGate reportKey="RelatorioCusto">
      <div className="print-container">
        <iframe
          src={environment.urlPowerBiRelatorioExtrato}
          className="print-iframe"
          frameBorder="0"
          allowFullScreen={true}
          title="Relatório de Custo"
        ></iframe>
        <button type="button" className="print-button" onClick={handlePrint}>
          <FaFilePdf size={24} color="#fff" />
        </button>
      </div>
    </Geo360AdmTenantGate>
  );
};

export default RelatorioCusto;
